import { reportProps } from './StopLossAggregateTable';
import React from 'react';
import {
  formatSavingsTableData,
  getSavingsProgramColumns,
  getSubtitleForSavingsTable,
} from '../core-utils/helper-utils/savingsUtilizationHelper';
import { useStores } from '../stores';
import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { observer } from 'mobx-react';

const cellStyles = {
  width: '50px',
  color: `${patientAccessTheme.palette.text.highemphasis} !important`,
  padding: '5px 10px !important',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '19.8px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[300],

  height: '35px',
};
const headerStyles = {
  color: `${patientAccessTheme.palette.status.white} !important`,
  padding: '5px 10px !important',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[700],
  height: '40px',
};
const titleStyles = {
  color: '#2E2F33',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '22.8px',
  padding: '0.75rem',
  margin: '0 !important',
};

export interface SavingsUtilizationTablesProps {
  index: number;
}
type CombinedProps = reportProps & SavingsUtilizationTablesProps;

const SavingsUtilizationTables: React.FC<CombinedProps> = observer(
  ({ index }) => {
    const quaterlyReportStore = useStores().quaterlyReportStore;

    const SavingsProgramTables = () => {
      const item = quaterlyReportStore.tableData[index];
      return (
        <PptReportTable
          data={formatSavingsTableData(item?.details, item?.totalSavings)}
          columns={getSavingsProgramColumns(
            item?.totalSavings,
            item?.columnName,
          )}
          cellStyles={cellStyles}
          headerStyles={headerStyles}
          titleStyles={titleStyles}
          title={`${item?.savings_program} - ${getSubtitleForSavingsTable(
            item?.drugCount,
            item?.claimCounts,
            item?.planPaid,
            item?.totalSavings,
          )}`}
        />
      );
    };
    return <SavingsProgramTables />;
  },
);
export default SavingsUtilizationTables;
